export const FIELD_TYPES_WITH_ENCRYPTION_SUPPORT = ["text", "inline_binary"];
